import {useEffect, useState} from "react";
import axios from "axios";
import {ApiUrl} from "../../auth/authMethods";
import BasicLoader from "../BasicLoader/BasicLoader";
import DownloadLogBookFile from "./DownloadLogBookFile";
import {normalizeTimestemp} from "../../utils/normalizeTimestemp";

export default function LogBookItemList({
                                            itens, setItens,
                                            loadItens, setLoadItens,
                                            baseUrl, url
                                        }) {

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (loadItens) {
            setLoading(true)

            axios.get(url)
                .then(function (response) {
                    console.log("searching data")
                    setItens(response.data)
                    // console.log(response.data.content)
                    setLoading(false)
                    setLoadItens(false)
                }).catch(function (errorReceived) {
                // aqui temos acesso ao erro, quando alguma coisa inesperada acontece:
                console.log(errorReceived);
            })

        }
    }, [loadItens]);

    return <>
        {loading ?
            <BasicLoader/> :
            itens.map((item, i) => <>
                <div>
                    <h6 className={'text-secondary'}>
                        Anotação feita em
                        <b className={'text-dark'}> {normalizeTimestemp(item.dateCreated)} </b>
                        pelo usuário
                        <b className={'text-dark'}> '{item.username}'</b>:
                    </h6>
                    <span className='container '>
                        {item.anotacao}
                    </span>
                </div>
                {item.arquivos.length > 0 &&

                    <div className='mt-2'>
                        <h6 className={'text-secondary'}>Arquivos: </h6>
                        <div className='text-center'>
                            {item.arquivos.map(file => <>
                                <DownloadLogBookFile file={file} baseUrl={baseUrl}/>
                            </>)}
                        </div>
                    </div>
                }
                <hr/>
            </>)
        }
    </>
}